import React, { useEffect, useState } from 'react';
import S2txtStream from '../s2txtStream/S2txtStream';
import firebase, { database } from '../../../utils/firebase'
import { useDispatch, useSelector } from 'react-redux';
import { setLanguageText, setLanguageTextLive, setLoadSuccess } from '../../../redux/actions/s2txtActions';
import { useHistory } from 'react-router';
import { storeEventUserId } from '../../../redux/actions/authActions';
import './s2txtb.scss'
import UserForm from './UserForm';
import { setFormSubmitState, setClearFormUserDetails } from '../../../redux/actions/s2txtActions'


const TransBody = () => {

    const getCombinedLang = (string) => {
        const ff = string.split(' ')
        if(ff[1]) {
          const newStr = ff[1].replace(/\(/, '')
          const finalStr = newStr.replace(/\)/, '')
          return ([ff[0], finalStr].join('-'))
        } else {
          return ff.join('')
        }
        
    }
    const langTxtDetails = useSelector(state => state.langTxtDetails)
    const eventDetails = useSelector(state => state.eventDetails)
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const { lvcconnectEventUserId } = user
    const history = useHistory()
    const attendanceReport = useSelector(state => state.attendanceReport)
    const { submitState, userDetails } = attendanceReport


    const [language, setLanguage] = useState(langTxtDetails.language);
    const [languagesData, setLanguagesData] = useState([]);
    const [langChange, setLangChange] = useState(language)
    const [btnstate, setBtnstate] = useState(true)
    const [userName, setUserName] = useState(user.username)
    const [noOfViewers, setNoOfViewers] = useState(+user.noViewers)
    const [attendState, setAttendState] = useState(false)
    const [attendArr, setAttendArr] = useState([])
    const [error, setError] = useState('error')
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        if (submitState) {
            if (userDetails.length === noOfViewers) {
                let hh = []
                const emails = userDetails.every(el => {
                    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(el.email).toLowerCase())
                })
                
                const names = userDetails.every(el => {
                    return el.name
                })
                
                const checks = userDetails.every(el => {
                    return el.check
                })
                
                
                if (!names) {
                    hh.push('name')
                }
                
                if (!emails) {
                    hh.push('email')
                }
                
                if (!checks) {
                    hh.push('status')
                }
                if (names && emails && checks) {
                    const reportRef = database.ref('Events').child(eventDetails.id).child('Users').child(lvcconnectEventUserId).child('AttendanceReport')
                    const obj = {
                        centerName: user.username,
                        centerCountry: user.country,
                        timeStamp: Date.now(),
                        userDetails: userDetails

                    }
                    reportRef.update(obj)
                    dispatch(setFormSubmitState(false))
                    setSuccess(true)
                } else {
                    setError(`Oops please check your ${hh.length > 1? hh.splice(0, hh.length - 1).join(', ') + ' and ' + hh[hh.length - 1] : hh} entrys`)
                    dispatch(setFormSubmitState(false))
                }
                
            }
        }
    }, [dispatch, noOfViewers, submitState, userDetails])
    
    useEffect(() => {
        let arr = []
        if(noOfViewers) {
            for(let i = 0; i < noOfViewers; i++) {
                arr.push(i)
            }
        }
        setAttendArr(arr)
    }, [noOfViewers])

    useEffect(() => {
        const langRef = firebase.database().ref('Languages')
        langRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }
            setLanguagesData(eData)
            document.querySelectorAll('.box').forEach(el => el.classList.remove('clicked'))
            const parent = document.querySelector("." + getCombinedLang(language))
            parent.querySelector('.box').classList.add('clicked')   
            eData.forEach(el =>{
                if(el.language === language) {
                    dispatch(setLanguageTextLive(el.live, el.langCode, language))
                }
            })
        })
        setLanguage(langTxtDetails.language)
    }, [dispatch, langTxtDetails.language, language])

    const handleChangeLang = () => {
        document.querySelector('.lang-c').classList.remove('hide')
        document.querySelector('.background').classList.remove('hide')
        document.querySelector('.nav-bg').classList.remove('hide') 
    }

    const handleChange = (lang) => {
        document.querySelectorAll('.box').forEach(el => el.classList.remove('clicked'))
        const jj = getCombinedLang(lang)
        const parent = document.querySelector("." + jj)
        parent.querySelector('.box').classList.add('clicked')
        setLangChange(lang)
        
    }

    const handleGoLive = () => {
        const eventRef = database.ref('Events').child(eventDetails.id).child('Users').child(lvcconnectEventUserId)     
        eventRef.update({
            preferredLanguage: langChange
        })
        dispatch(setLanguageText(langChange))
        document.querySelector('.lang-c').classList.add('hide')
        document.querySelector('.background').classList.add('hide')
        document.querySelector('.nav-bg').classList.add('hide') 
        dispatch(setLoadSuccess())
    }

    const handleLogout = () => {

        const eventRef = database.ref('Events').child(eventDetails.id).child('Users').child(lvcconnectEventUserId)     
        eventRef.update({
            loggedOut: Date.now()
        })
        dispatch(storeEventUserId(''))
        history.push('/')
    }

    useEffect(() => {
        if (language === langChange) {
            setBtnstate(true)
        } else {
            setBtnstate(false)
        }  
    }, [language, langChange]);

    const handleCancelClick = (e) => {
        e.preventDefault()
        setSuccess(false)
        document.querySelector('.stream-form-container').classList.add('hide')
        document.querySelector('.background').classList.add('hide')
        document.querySelector('.nav-bg').classList.add('hide') 
    }

    const handleSubmitClick = (e) => {
        e.preventDefault()
        if(attendState) {
            setError('error')
            dispatch(setClearFormUserDetails())
            dispatch(setFormSubmitState(true))
            
        } 

        if (!attendState) {
            const eventRef = database.ref('Events').child(eventDetails.id).child('Users').child(lvcconnectEventUserId)     
            eventRef.update({
                noOfViewers: noOfViewers
            })
            setError('error')
            setAttendState(true)
        }
    }

    const handleNoClick = () => {
        setAttendState(false)
    }

    const handleAttendClick = () => {
        setSuccess(false)
        document.querySelector('.stream-form-container').classList.remove('hide')
        let elmnt = document.querySelector(".s2txtMain");
        let y = elmnt.scrollHeight;
        document.querySelector('.background').style.height = `${y}px`
        document.querySelector('.background').classList.remove('hide')
        document.querySelector('.nav-bg').classList.remove('hide') 
        document.querySelector(`.intro`).scrollIntoView(); 
        setTimeout(() => {
            let elmnt = document.querySelector(".s2txtMain");
            let y = elmnt.scrollHeight;
            document.querySelector('.background').style.height = `${y}px`
        }, 100);
    }




    return (
        <main className="intro">
            <div className="banner"></div>
            {/* <img src="https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60" alt="" className='banner'/> */}

            <h1 className='mob welcome'>Welcome to Church, {userName.split(' ').filter(el => el.length > 0).map(el => {
                return el[0].toUpperCase() + el.slice(1).toLowerCase()
                }).join(' ')}!
            </h1>

            <div className="lang marg">
                <div className="left">
                    <p>Language:</p>
                    <p>{language}</p>
                    <button onClick={handleChangeLang}>Change</button>

                    <div className='lang-c hide'>
                        <h3>Select Language</h3>
                        <div className="contain-lang">
                    
                            <div className="aside-lang-left">

                                {languagesData.map((el, i) => {
                                    if(i < ((languagesData.length)/2)) {
                                        return (
                                            <div className={`p-lang ${getCombinedLang(el.language)}`} onClick={() =>{handleChange(el.language)}} key={el.id}>
                                                <div className='box '></div>
                                                <div>{el.language}</div>
                                            </div>
                                        )
                                    }
                                })}                
                            </div>
                                        
                            <div className="aside-lang-right">
                                {languagesData.map((el, i) => {
                                        if(i >= ((languagesData.length)/2)) {
                                            return (
                                                <div className={`p-lang ${getCombinedLang(el.language)}`} onClick={() =>{handleChange(el.language)}} key={el.id}>
                                                    <div className='box '></div>
                                                    <div>{el.language}</div>
                                                </div>
                                            )
                                        }
                                })}
                                
                            </div>                 
                        </div>  
                        <button disabled={btnstate} onClick={handleGoLive} >Go Live</button>
                    </div>
                </div>

                

                <div className="right">
                    <h1 className='desk welcome'>Welcome to Church, {userName.split(' ').filter(el => el.length > 0).map(el => {
                        return el[0].toUpperCase() + el.slice(1).toLowerCase()
                        }).join(' ')}!
                    </h1>
                    <button title='You are about to logout' onClick={handleLogout}>Logout</button>
                </div>
           
            </div>


            <div className="attend-btn marg">
                <button onClick={handleAttendClick}>Update Service Attendance</button>
            </div>
            

            <S2txtStream username={userName} language={language} setSuccess={setSuccess}  />

            
            

            {!success? 
                <div className="stream-form-container hide">
                <h3>Attendance Report</h3>
                {attendState?
                    <p className='no-of-users'>No of Viewers  - <span>{noOfViewers}</span> <i class="far fa-edit" onClick={handleNoClick}></i></p>
                    : ''
                }
                
                <form action="">
                    <div className="u-f-container">
                    {attendState? 
                        attendArr.map((el, i) => {
                            return (
                                
                                    <UserForm index={i} />
                               
                            )
                        })
                        
                        :
                        <div className="form-element">
                            <label htmlFor="stream-noOfviewers">No of viewers</label>
                            <input className='field' type="number" name='stream-noOfviewers' id='stream-noOfviewers' 
                            value={noOfViewers} onChange={(e) => setNoOfViewers(+e.target.value)} />
                        </div> 
                    }

                    
                    </div>

                    <div className='error-card'>
                            {attendState? 
                                <p className={error === 'error' ? 'hidden' : 'hidden fail'}>{error}</p> : ''   
                            }
                        </div>

                    <div className="buttons">
                        <button onClick={handleCancelClick}>Cancel</button>
                        <button onClick={handleSubmitClick}>Update Attendance Report</button>
                    </div>
                </form>
            </div>

            : 
            <div className="stream-form-container hide">
                <h3>Attendance Report</h3>
                <div className="success">
                    <p>Thanks for submitting your service attendance report! </p>
                    <i class="fas fa-check-square"></i>
                </div>

                <form action="">
                    <div className="buttons">
                        <button onClick={handleCancelClick}>Cancel</button>
                        {/* <button onClick={handleSubmitClick}>Update Attendance Report</button> */}
                    </div>
                </form>
            </div>
            }
            
            
        </main>
    )
}

export default TransBody